export default __webpack_public_path__ + "static/media/wojak-axe.ed188fbf.png";